import type { IxcTradeV1TradeKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../util/routing/entity-paths';

export const TRADE_BASE_PATH = getResolvedPath('/clearing/operations/trade/utc');

export const getTradePath: EntityPathBuilder<IxcTradeV1TradeKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return TRADE_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.tradeId) {
        return undefined;
      }

      return getResolvedPath(`${TRADE_BASE_PATH}/$tradeId`, context.keys);
    }
  }
};

export function getTradeDetailPath(tradeId: string | undefined) {
  if (!tradeId) {
    return undefined;
  }

  return getTradePath({ kind: 'detail', keys: { tradeId } });
}
